require('./mortgageRequestCoHolder.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
const get = require('lodash/object/get');
const filter = require('lodash/collection/filter');

// @ utilities
const { recordProcess, PROC_START, PROC_CANCEL } = require('utilities/tagging');

// @ track processes
const { PROC_ADD_CO_HOLDER } = require('constants/mortgageRequestProcesses');

// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const CoHolderRow = require('components/mortgageRequest/mortgageRequestCoHolder/coHolderRow');
const {
    MortgageRequestHolderInformation
} = require('components/mortgageRequest/mortgageRequestHolderInformation/mortgageRequestHolderInformation');
const { LoadingSection } = require('commonsComponents/loadingSection');
const MortgageRequestNoCoHolderMessage = require('components/mortgageRequest/mortgageRequestNoCoHolderMessage/mortgageRequestNoCoHolderMessage');

//@actions
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const coHolderActions = require('actions/mortgageRequest/mortgageRequestCoHolder');

class MortgageRequestCoHolder extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            holderId: null,
            obcd: null,
            numerodecontrato: null,
            orderNm: 0
        };

        this.handleHolderRadioSelect = this.handleHolderRadioSelect.bind(this);
        this.handleCancelAddCoHolder = this.handleCancelAddCoHolder.bind(this);
    }

    componentWillMount() {
        const { requestCoHolders } = this.props;
        requestCoHolders();
    }

    componentDidMount() {
        recordProcess(PROC_ADD_CO_HOLDER, PROC_START);
    }

    componentWillReceiveProps(nextProps) {
        const nextIdExpediente = nextProps.mortgageRequestState.get('idExpediente');
        const dataProprietorsCount = nextProps.dataProprietors.get('data', []).count();
        const stateIsLoading = nextProps.mortgageRequestState.get('isFetching');
        const dataProprietorsIsLoading = nextProps.dataProprietors.get('isFetching');
        //got id, missing data on state, state finished the loading, manager in initial state
        if (
            nextIdExpediente &&
            !dataProprietorsCount &&
            stateIsLoading === false &&
            typeof dataProprietorsIsLoading === 'undefined'
        ) {
            nextProps.requestDataProprietor(nextIdExpediente);
        }

        if (dataProprietorsCount) {
            this.setState({ orderNm: dataProprietorsCount + 1 });
        }
    }

    handleCancelAddCoHolder(evt) {
        evt.preventDefault();
        recordProcess(PROC_ADD_CO_HOLDER, PROC_CANCEL);
        this.props.history.push('/myprofile/mortgage/panel');
    }

    handleHolderRadioSelect(value) {
        const radioValues = value.split('|');
        if (radioValues.length === 3) {
            this.setState({
                holderId: radioValues[0] || '',
                obcd: radioValues[1] || '',
                numerodecontrato: radioValues[2] || ''
            });
        }
    }

    tableRows(results) {
        const { dataProprietors } = this.props;
        const currentCoHolders = dataProprietors.get('data').toJS();
        let flag = false;
        //Existing co holders
        const currentCoHoldersNumbers = currentCoHolders.map(x => x.numclienteobcd.toString());

        const tableRows = results.map(intervener => {
            let coHolders = intervener
                .getIn(['intervinientes', 'listaConsultaTitu', 'datoConsultaTitu'])
                .toJS();
            const coHolderAccount = intervener.get('cuenta');

            //We render only the interveners that haven't been added as coholders
            coHolders = filter(coHolders, obj => {
                const currentValue = get(obj, 'identifPersona.codigodepersona', '').toString();
                return !currentCoHoldersNumbers.includes(currentValue);
            });

            if (coHolders.length > 0) {
                flag = true;
                return coHolders.map(coHolder => {
                    return (
                        <CoHolderRow
                            key={get(coHolder, 'identifPersona.codigodepersona', Math.random())}
                            coHolder={coHolder}
                            coHolderAccount={coHolderAccount}
                            coHolderSelected={
                                this.state.holderId +
                                '|' +
                                this.state.obcd +
                                '|' +
                                this.state.numerodecontrato
                            }
                            onHandleHolderRadioSelect={this.handleHolderRadioSelect}
                        />
                    );
                });
            }
        });

        if (flag) {
            return tableRows;
        } else {
            return false;
        }
    }

    render() {
        const { coHolder } = this.props;
        let backSection = (
            <div>
                <br />
                <div className="row">
                    <div className="col-md-10">
                        <a
                            href="#"
                            className="ok-link"
                            onClick={this.handleCancelAddCoHolder}
                        >
                            {formatText('mortgageRequestHolderInformation-returnLink')}
                        </a>
                    </div>
                </div>
            </div>
        );
        let tableRows;
        let formPersonalData;
        let content;

        if (this.state.holderId && this.state.obcd && this.state.orderNm) {
            formPersonalData = (
                <MortgageRequestHolderInformation
                    isHolder={false}
                    holderId={this.state.holderId}
                    orderNm={this.state.orderNm}
                />
            );
            backSection = '';
        }

        if (coHolder.get('isFetching')) {
            content = (
                <ContentBox>
                    <LoadingSection />
                </ContentBox>
            );
        } else if (coHolder.get('cuentasCotitulares')) {
            if (coHolder.get('cuentasCotitulares').size) {
                tableRows = this.tableRows(coHolder.get('cuentasCotitulares'));
                if (tableRows) {
                    content = (
                        <ContentBox
                            title={formatText('mortgageRequestCoHolder-subtitleCoHolder')}
                            smallTitle={true}
                        >
                            <OKTable className="mortgage-request-co-holder-view__table">
                                <thead>
                                    <OKTableRow
                                        asHeader={true}
                                        className="broker-search-results__table-header"
                                    >
                                        <OKTableCell
                                            asHeader={true}
                                            className="mortgage-request-co-holder-view__table-header-cell--radio"
                                        />
                                        <OKTableCell
                                            asHeader={true}
                                            className="mortgage-request-co-holder-view__table-header-cell--big"
                                        >
                                            <FormattedText
                                                value="mortgageRequestCoHolder-tableHeaderName"
                                                format="uppercase"
                                            />
                                        </OKTableCell>
                                        <OKTableCell
                                            asHeader={true}
                                            className="mortgage-request-co-holder-view__table-header-cell--big"
                                        >
                                            <FormattedText
                                                value="mortgageRequestCoHolder-tableHeaderContractNumber"
                                                format="uppercase"
                                            />
                                        </OKTableCell>
                                        <OKTableCell
                                            asHeader={true}
                                            className="mortgage-request-co-holder-view__table-header-cell--big"
                                        >
                                            <FormattedText
                                                value="mortgageRequestCommons-typeInterventionText"
                                                format="uppercase"
                                            />
                                        </OKTableCell>
                                        <OKTableCell
                                            asHeader={true}
                                            className="mortgage-request-co-holder-view__table-header-cell--medium"
                                        >
                                            <FormattedText
                                                value="mortgageRequestCommons-currentBalanceText"
                                                format="uppercase"
                                            />
                                        </OKTableCell>
                                    </OKTableRow>
                                </thead>
                                <tbody>
                                    {tableRows}
                                </tbody>
                            </OKTable>
                            {backSection}
                            {formPersonalData}
                        </ContentBox>
                    );
                } else {
                    content = <MortgageRequestNoCoHolderMessage />;
                }
            } else {
                content = <MortgageRequestNoCoHolderMessage />;
            }
        } else {
            content = <MortgageRequestNoCoHolderMessage />;
        }

        return content;
    }
}

MortgageRequestCoHolder.propTypes = {
    history: PropTypes.object.isRequired,
    coHolder: PropTypes.object,
    requestDataProprietor: PropTypes.func,
    requestCoHolders: PropTypes.func,
    dataProprietors: PropTypes.object,
    mortgageRequestState: PropTypes.object
};

module.exports.constructor = MortgageRequestCoHolder;
module.exports.MortgageRequestCoHolder = connect(
    state => ({
        coHolder: state.mortgageRequestCoHolder,
        dataProprietors: state.mortgageRequestDataProprietor,
        mortgageRequestState: state.mortgageRequestState
    }),
    {
        requestDataProprietor: dataProprietorActions.requestDataProprietor,
        requestCoHolders: coHolderActions.requestCoHolders
    }
)(withRouter(MortgageRequestCoHolder));
